// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import {
  Button,
  ButtonComposed,
  Link,
  modal,
  itemList,
  Select,
  Input,
  RadioTabs,
} from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
import { processingUser } from "model/gql/mutations";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./AddProcessingUserAccess.m.scss";

const CreateUser = itemList.MutationFactory(processingUser.access.add);

@themr("@lifepay/AddUserAccess", styles)
export default class AddUserAccess extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    onSuccess: PropTypes.func,
    username: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: null,
      submitButtonState: "normal",
      objectType: "",
      objectValue: "",
      hasAccess: "true",
    };
  }

  handleInput = ({ id, value }) => {
    this.setState({ [id]: value });
  };

  render() {
    const { theme, username, onSuccess } = this.props;
    const {
      loading,
      error,
      submitButtonState,
      objectType,
      objectValue,
      hasAccess,
    } = this.state;
    return (
      <modal.ModalController>
        {({ isOpen, close, open }) => {
          return (
            <React.Fragment>
              <div className={classnames(theme.control)}>
                <Button type={"alt"} size={"small"} onClick={open}>
                  {"Добавить доступ"}
                </Button>
              </div>
              <modal.ModalBox
                isOpen={isOpen}
                close={() => (!loading ? close() : null)}
                theme={{
                  inner: theme.modal,
                }}
              >
                <CreateUser>
                  {(AddUserAccess, { data, dataState }) => {
                    const submit = (
                      <div className={classnames(theme.submit)}>
                        <ButtonComposed
                          state={submitButtonState}
                          disabled={submitButtonState !== "normal"}
                          type={"main"}
                          size={"small"}
                          text={"Подтвердить"}
                          theme={{
                            wrapper: theme.button,
                          }}
                          onClick={() => {
                            this.setState({
                              loading: true,
                              submitButtonState: "loading",
                            });
                            AddUserAccess({
                              variables: {
                                username,
                                objectType,
                                objectValue,
                                hasAccess: hasAccess === "true",
                              },
                              update: (proxy, response) => {
                                this.setState({
                                  loading: false,
                                  submitButtonState: "normal",
                                });
                                onSuccess && onSuccess();
                                close();
                              },
                            }).catch((e) => {
                              this.setState({
                                loading: false,
                                error: e,
                                submitButtonState: "error",
                              });
                            });
                          }}
                        >
                          {"Добавить"}
                        </ButtonComposed>
                        <Button
                          type={loading ? "disabled" : "alt"}
                          size={"small"}
                          disabled={loading}
                          theme={{
                            wrapper: theme.button,
                          }}
                          onClick={() => {
                            close();
                          }}
                        >
                          {"Отмена"}
                        </Button>
                      </div>
                    );

                    return (
                      <div className={classnames(theme["modal-content"])}>
                        <form
                          autoComplete="off"
                          className={classnames(theme.form)}
                        >
                          <div className={classnames(theme.inputs)}>
                            <div
                              className={classnames(theme.summary)}
                            >{`Добавить доступ`}</div>

                            <Select
                              id={"objectType"}
                              value={objectType}
                              hideChooseAll
                              options={[
                                { value: "bank", label: "bank" },
                                { value: "branch", label: "branch" },
                                { value: "tid", label: "tid" },
                                { value: "binrange", label: "binrange" },
                              ]}
                              onChange={this.handleInput}
                            >
                              {"Тип доступа (objectType)"}
                            </Select>
                            <Input
                              id={"objectValue"}
                              value={objectValue}
                              controlled
                              onChange={this.handleInput}
                            >
                              {"Значение доступа (objectValue)"}
                            </Input>
                            <RadioTabs
                              id={"hasAccess"}
                              onChange={this.handleInput}
                              tabs={[
                                {
                                  id: "true",
                                  value: true,
                                  component: "Разрешить",
                                },
                                {
                                  id: "false",
                                  value: false,
                                  component: "Запретить",
                                },
                              ]}
                              value={hasAccess}
                            >
                              {"Доступ"}
                            </RadioTabs>
                            {error ? (
                              <React.Fragment>
                                <div className={classnames(theme.summary)}>
                                  {error.message}
                                </div>
                                <div className={classnames(theme.summary)}>
                                  <Link
                                    type={"negative"}
                                    withRouter={false}
                                    onClick={() => {
                                      this.setState({
                                        error: null,
                                        submitButtonState: "normal",
                                      });
                                    }}
                                  >
                                    {"Очистить ошибку"}
                                  </Link>
                                </div>
                              </React.Fragment>
                            ) : null}
                          </div>
                          {submit}
                        </form>
                      </div>
                    );
                  }}
                </CreateUser>
              </modal.ModalBox>
            </React.Fragment>
          );
        }}
      </modal.ModalController>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/list-items/ProcessingUser/ProcessingUserAccesses/AddProcessingUserAccess/AddProcessingUserAccess.js